class CountryPopup extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('[data-country-popup-wrapper]');
    this.overlay = this.querySelector('[data-country-popup-overlay]');
    this.buttonStay = this.querySelector('[data-country-popup-stay]');
    this.buttonClose = this.querySelector('[data-country-popup-close]');
    this.cookieName = 'country_popup';

    const defaults = {
      currentCountryCode: '',
      locationApiUrl: '',
      locationFieldName: '',
      expiresInDays: 0,
      popupMessages: {}
    };
    let dataOptions = {};
    if (this.dataset.options) {
      try { dataOptions = JSON.parse(this.dataset.options); } catch (e) { dataOptions = {}; }
    }
    this.options = { ...defaults, ...dataOptions };

    this.init();

    // When you edit the popup inside the theme editor, show it fresh again
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        this.removeCookie(this.cookieName);
        this.removeCookie(this.cookieName + '-country_code');
      });
    }
  }

  // --- small cookie helpers (these replace the old js-cookie file) ---
  setCookie(name, value, days) {
    let expires = '';
    if (days && parseFloat(days) > 0) {
      const date = new Date();
      date.setTime(date.getTime() + parseFloat(days) * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }
  getCookie(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop()) : '';
  }
  removeCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  init() {
    // Test Mode (0 days): clear the cookie so the popup shows on every visit
    if (parseInt(this.options.expiresInDays, 10) === 0) {
      this.removeCookie(this.cookieName);
    }
    if (!this.shouldShow()) return;

    this.getCountryCode((countryCode) => this.renderPopup(countryCode));

    if (this.buttonStay) this.buttonStay.addEventListener('click', () => this.closePopup());
    if (this.buttonClose) this.buttonClose.addEventListener('click', () => this.closePopup());
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay && !this.noClose) this.closePopup();
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen && !this.noClose) this.closePopup();
    });
  }

  shouldShow() {
    if (this.getCookie(this.cookieName)) return false;
    const messages = this.options.popupMessages || {};
    if (Object.keys(messages).length === 0) return false;
    return true;
  }

  getCountryCode(callback) {
    const cached = this.getCookie(this.cookieName + '-country_code');
    if (cached) { this.countryCode = cached; return callback(cached); }

    const apiUrl = this.options.locationApiUrl;
    const field = this.options.locationFieldName || 'country_code';
    if (!apiUrl) return;

    fetch(apiUrl)
      .then((r) => r.json())
      .then((data) => {
        const code = data && data[field] ? data[field] : '';
        if (code) {
          this.countryCode = code;
          this.setCookie(this.cookieName + '-country_code', code, 1 / 24); // cache 1 hour
        }
        callback(code);
      })
      .catch(() => {});
  }

  renderPopup(countryCode) {
    if (!countryCode || !this.options.currentCountryCode) return;
    if (countryCode === this.options.currentCountryCode) return;

    const messages = this.options.popupMessages || {};
    const data = messages[countryCode] || messages['ROW'];
    if (!data) return;

    this.noClose = !!data.hideCloseButton;
    this.wrapper.classList.toggle('country-popup--no-close-button', this.noClose);

    this.setHTML('[data-country-popup-title]', data.countryTitle);
    this.setHTML('[data-country-popup-name-title]', data.countryName);
    this.setHTML('[data-country-popup-text]', data.countryBody);
    this.setHTML('[data-country-popup-label]', data.countryButton);
    const urlEl = this.querySelector('[data-country-popup-url]');
    if (urlEl) urlEl.href = data.countryUrl || '#';
    if (this.buttonStay) this.buttonStay.value = data.countryStay || '';

    this.openPopup();
    this.setCookie(this.cookieName, 'shown', this.options.expiresInDays);
  }

  setHTML(selector, value) {
    const el = this.querySelector(selector);
    if (el) el.innerHTML = value || '';
  }

  openPopup() {
    this.isOpen = true;
    this.overlay.hidden = false;
    requestAnimationFrame(() => this.overlay.classList.add('is-open'));
    document.body.classList.add('country-popup-open');
  }

  closePopup() {
    this.setCookie(this.cookieName, 'closed', this.options.expiresInDays);
    this.isOpen = false;
    if (this.overlay) {
      this.overlay.classList.remove('is-open');
      this.overlay.hidden = true;
    }
    document.body.classList.remove('country-popup-open');
  }
}

if (!customElements.get('country-popup')) {
  customElements.define('country-popup', CountryPopup);
}